import RGB from '../../colors/RGB';

export default class Light {
	light: RGB;
	color: RGB;
	intensity: number;

	constructor () {
		this.light = new RGB(1.0, 1.0, 1.0);
		this.color = new RGB(1.0, 1.0, 1.0);
		this.intensity = 0.5;
	}

	updateLight () {
		this.light.r = this.color.r * this.intensity;
		this.light.g = this.color.g * this.intensity;
		this.light.b = this.color.b * this.intensity;
	}
}
